import { Box, Card, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import Currency from '../../../commonModules/Currency';

class SpendingDetails extends Component {
    state = {  }
    render() {
        const { spending } = this.props;
        return (
                <Card >
                    <Box p={1}>
                        <List>                                      
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography variant="h6">Reste à pointer:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        color="secondary"
                                        primary={
                                            <Typography color="secondary" variant="subtitle1">
                                                <Currency suffix=" FCFA" value={spending.spending_rest_to_match} />
                                            </Typography>
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>  
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography >Montant total:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        color="secondary"
                                        primary={
                                            <Typography variant="subtitle1">
                                                <Currency suffix=" FCFA" value={spending.spending_amount} />
                                            </Typography>
                                        }
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>                                                
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Date encaissement:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        primary={new Date(spending.spending_date).toLocaleDateString("fr-FR")}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            
                            <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Banque:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_bank} />
                                </ListItemSecondaryAction>
                            </ListItem>
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Poste:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_post} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Référence:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_ref} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                            {/* <ListItem>
                                <ListItemText
                                    primary={
                                        <Typography>Description:</Typography>
                                    }
                                /> 
                                <ListItemSecondaryAction>
                                    <ListItemText primary={spending.spending_desc} />
                                </ListItemSecondaryAction>
                            </ListItem> */}
                        </List>
                        <Box p={1}>
                            <Typography variant="caption">{spending.spending_desc}</Typography>
                        </Box>
                    </Box>
                </Card>
        );
    }
}

export default SpendingDetails;